import type { SupportedLanguage } from "../api/userInfo";

export type FormatDateOptions = { showTime?: boolean };

const dateFormatters = new Map<SupportedLanguage, Intl.DateTimeFormat>();
const timeFormatters = new Map<SupportedLanguage, Intl.DateTimeFormat>();

const getFormatter = (
  formatters: Map<SupportedLanguage, Intl.DateTimeFormat>,
  locale: SupportedLanguage,
  options: Intl.DateTimeFormatOptions
) => {
  const cached = formatters.get(locale);
  if (cached) return cached;
  const formatter = new Intl.DateTimeFormat(locale, options);
  formatters.set(locale, formatter);
  return formatter;
};

export const formatDate = (
  dateString: string,
  locale: SupportedLanguage,
  { showTime }: FormatDateOptions = {}
): string => {
  const date = new Date(dateString);
  const { day, month, year } = Object.fromEntries(
    getFormatter(dateFormatters, locale, { year: "numeric", month: "long", day: "numeric" })
      .formatToParts(date)
      .map(part => [part.type, part.value])
  );
  const formattedDate = `${day} ${month} ${year}`;
  if (!showTime) {
    return formattedDate;
  }
  const formattedTime = getFormatter(timeFormatters, locale, {
    hour12: locale === "en",
    hour: "numeric",
    minute: "numeric",
  }).format(date);
  return `${formattedDate} ${formattedTime}`;
};
